<template>
  <li v-if="loaded">
    <span class="q-title">{{q.title}}</span>
    <p
      class="prpgress-sakura animated zoomIn"
      id="pregress-num1"
      :class="{'sakura-full': lastPercent === 100, 'sakura-80': lastPercent < 100, 'sakura-50': lastPercent <= 50,'sakura-25': lastPercent < 25}"
    >{{Math.round(lastPercent)}}%</p>
    <div class="container">
      <div class="progress">
        <div class="progress-bar progress-bar-info" :style="{width: `${lastPercent}%`}"></div>
      </div>
    </div>

    <div class="good-mark" v-if="lastPercent === 100">
      <img src="@/assets/img/good.png" />
    </div>
  </li>
</template>

<script>
/* eslint-disable no-console */

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  name: "toc",
  props: {
    q: Object,
    cid: String
  },
  data() {
    return {
      public: process.env.BASE_URL,
      lastData: {},
      lastQuestions: [],
      loaded: false
    };
  },
  mounted() {
    console.log("toc mounted");
    const history = localStorage.getItem(
      `SukenDrill::${this.cid}_${this.q.id}::HISTORY`
    );
    const lq = localStorage.getItem(
      `SukenDrill::${this.cid}_${this.q.id}::QUESTIONANSWER`
    );

    if (history) {
      this.lastData = JSON.parse(history);
    } else {
      this.lastData = undefined;
    }
    if (lq) {
      this.lastQuestions = JSON.parse(lq);
    } else {
      this.lastQuestions = undefined;
    }

    this.loaded = true;
  },
  computed: {
    lastCorrectNum() {
      if (this.loaded && this.lastQuestions) {
        return this.lastQuestions.filter(e => e === true).length + (this.q.questions.length - this.lastQuestions.length);
      }
      return null;
    },
    lastPercent() {
      if (this.loaded && this.lastQuestions) {
        return (this.lastCorrectNum / this.q.questions.length) * 100 * 1;
      }
      return 0;
    }
  },
  methods: {
    start(idx) {
      console.log(idx);
      this.$emit("start", idx);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.q-title {
  display: inline-block;
  width: calc(100% - 7em);
  line-height: 2rem;
}

@media (max-width: 639px) {
  .q-title {
    display: inline-block;
    width: calc(100% - 5em);
    line-height: 2rem;
  }
}

.good-mark {
  position: absolute;
  right: -20px;
  top: -20px;

  width: 64px;
}

.good-mark img {
  width: 100%;
}
</style>
